import { actionCreator } from '@ardoq/rxbeach';
import type {
  AddWidgetToDashboardPayload,
  SetSelectedDashboardPayload,
  OpenAddToDashboardDialogPayload,
} from './types';

export const openAddToDashboardDialog =
  actionCreator<OpenAddToDashboardDialogPayload>(
    '[addToDashboard] open dialog'
  );

export const closeAddToDashboardDialog = actionCreator(
  '[addToDashboard] close dialog'
);

export const addWidgetToDashboard = actionCreator<AddWidgetToDashboardPayload>(
  '[addToDashboard] add widget to dashboard'
);

export const addWidgetToDashboardSucceeded = actionCreator(
  '[addToDashboard] add widget succeeded'
);

export const addWidgetToDashboardFailed = actionCreator(
  '[addToDashboard] add widget failed'
);

export const setSelectedDashboard = actionCreator<SetSelectedDashboardPayload>(
  '[addToDashboard] set selected dashboard'
);

export const setCustomWidgetName = actionCreator<string>(
  '[addToDashboard] set custom widget name'
);
